module.exports = __webpack_public_path__ + "img/ico5.ccfc69b3.png";